import { Direction } from '@angular/cdk/bidi';
import { Component, Inject, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { CLOSE, PICK_ADDRESS, PICK_DESTINATION, PICK_ORIGIN, PICK_STOP } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { MAP_OBJECT_TOKEN } from 'src/app/modules/route-planner/services/map/map.service';

export interface AddressMarkerData {
  address: Address;
  title: string;
  /** When true, show the "Add stop" button (stop input is visible on form). */
  showAddStopButton?: boolean;
}

@Component({
    selector: 'app-address-autocomplete-marker',
    templateUrl: './address-autocomplete-marker.component.html',
    styleUrls: ['./address-autocomplete-marker.component.scss'],
    standalone: false
})
export class AddressAutocompleteMarkerComponent implements OnInit {
  direction: Direction;
  originButtonTitle: string;
  destinationButtonTitle: string;
  addStopButtonTitle: string;
  closeText: string;
  chooseAddressText: string;

  constructor(
    @Inject(MAP_OBJECT_TOKEN)
    public data: AddressMarkerData,
    private readonly languageService: LanguageService,
    private readonly resizeService: ResizeService,
  ) {}

  ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.originButtonTitle = PICK_ORIGIN[language.language];
      this.destinationButtonTitle = PICK_DESTINATION[language.language];
      this.addStopButtonTitle = PICK_STOP[language.language];
      this.closeText = CLOSE[language.language];
      this.chooseAddressText = PICK_ADDRESS[language.language];
    });
  }

  isInMobileView() {
    return this.resizeService.isMobile;
  }
}
